module.exports = __webpack_public_path__ + "img/404-error-page-not-found-with-people-connecting-a-plug-animate.4ac32f57.svg";